import React, { useContext } from 'react';
import { Checkbox, Col, DatePicker, Form, Row, Select, Tooltip } from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import { LanguageContext } from 'contexts/LanguageContext';
import moment from 'moment-timezone';
import { InfoCircleOutlined } from '@ant-design/icons';

interface CampaignReadyProps {
	campaignName: string;
	campaignWhenToSend: number | null;
	campaignScheduledDate?: moment.Moment | null;
	campaignWorktime: boolean;
	whenToSendMessage?: string;
	ScheduledDateMessage?: string;
	onChangeWorktime: (value: boolean) => void;
	onChangeWhenToSend: (value: number) => void;
	onChangeScheduledDate: (date: moment.Moment | null) => void;
}

const rowStyle1: React.CSSProperties = {
	height: 100,
	display: 'flex',
	justifyContent: 'center',
};

export default function CampaignReady(props: CampaignReadyProps) {
	const { campaignName } = props;
	const { campaignWhenToSend, onChangeWhenToSend } = props;
	const { campaignScheduledDate, onChangeScheduledDate } = props;
	const { campaignWorktime, onChangeWorktime } = props;
	const { dictionary } = useContext(LanguageContext);
	const whenToSendStatus = props.whenToSendMessage ? 'error' : undefined;
	const ScheduledDateStatus = props.ScheduledDateMessage ? 'error' : undefined;

	function handleChangeScheduledDate(date: moment.Moment | null) {
		if (date) {
			date = date.tz('America/Sao_Paulo');
			date.seconds(0);
		}

		onChangeScheduledDate(date);
	}

	return (
		<>
			<Row style={{ minHeight: 100, paddingTop: '2em' }}>
				<Title level={2}>
					<Text type="gray-9">
						{`${dictionary.campaign_ready_1} \"${campaignName}\" ${dictionary.campaign_ready_2}`}
					</Text>
				</Title>
			</Row>
			<Row className="pt-10" gutter={[12, 12]} style={rowStyle1}>
				<Col span={campaignWhenToSend === 3 ? 12 : 24}>
					<Form.Item validateStatus={whenToSendStatus} help={props.whenToSendMessage}>
						<Select
							{...{
								defaultValue: campaignWhenToSend || undefined,
								size: 'large',
								style: { width: '100%' },
								placeholder: dictionary.when_to_send,
								onChange: onChangeWhenToSend,
							}}
						>
							<Select.Option value={1}>{dictionary.now}</Select.Option>
							<Select.Option value={2}>{dictionary.later_manually}</Select.Option>
							<Select.Option value={3}>{dictionary.schedule}</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				{campaignWhenToSend === 3 && (
					<Col span={12}>
						<Form.Item validateStatus={ScheduledDateStatus} help={props.ScheduledDateMessage}>
							<DatePicker
								style={{ width: '100%' }}
								size="large"
								showTime={{ format: 'HH:mm' }}
								defaultValue={campaignScheduledDate}
								onChange={handleChangeScheduledDate}
							/>
						</Form.Item>
					</Col>
				)}
			</Row>
			<Row>
				<Col span={24}>
					<Form.Item style={{ marginTop: -10 }}>
						<Checkbox
							checked={campaignWorktime}
							onChange={(e) => onChangeWorktime(e.target.checked)}
						>
							{dictionary.campaign_worktime_title}
						</Checkbox>

						<Tooltip title={dictionary.campaign_worktime_tooltip}>
							<span style={{ marginLeft: 2, cursor: 'pointer' }}>
								<InfoCircleOutlined style={{ fontSize: 16, color: '#1890ff' }} />
							</span>
						</Tooltip>
					</Form.Item>
				</Col>
			</Row>
			<Row style={{ height: 100 }}></Row>
		</>
	);
}
